
import React, { Component } from 'react';
import Row from '../Row';
import Col from '../Col';
import Form from '../Form';
import Button from '../Button';
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';
import * as markerjs2 from 'markerjs2';

class Marker extends Component {
  state = {
    index: 0,
    image: {},
    images: [],
    loader: false,
    showMarker: false
  }

  async componentDidMount() {
    const { images } = this.props;    
      this.setState({
        images: images,
        image: images[0],
        isLoading: false
      })
  }

  invokeMarkers = () => {
    let markerArea = new markerjs2.MarkerArea(document.getElementById('imageToAnnotate'));
    markerArea.addRenderEventListener(dataUrl => {
      this.setAnnotatedImages(dataUrl)
    });
    // markerArea.settings.displayMode = 'popup';
    markerArea.show();
    markerArea.addCloseEventListener(() => {
        this.setState({ showMarker: false})
    })
  }
  setAnnotatedImages = async (uri) => {

    try {
      let images = this.state.images;
      images = images.map((data, i) => {
        if (i === this.state.index) {
          return uri
        } else {
          return data
        }
      })
      this.setState({ image: uri, images: images, showMarker: false })
      toast.success('Annotation image has been saved.', { autoClose: 1000,position:'top-center' });
      localStorage.setItem('isAnnotationImageUpload',true);
    }
    catch(error){
      toast.error('There seems to be some problem with the low memory, unable to process the request now.', { autoClose: 1000,position:'top-center' });
     return false;
    }
  }

  showMarkerJs = () => {
    this.setState({ showMarker: true})
    this.invokeMarkers();
  }

  hideMarkers = (type) => {
    if(type === false) {
    } else {
      this.setState({ showMarker: false})
    }
    var test = document.getElementsByClassName('__markerjs2_');
    for (var i = 0; i < test.length; i++) {
      test[i].style.display = "none";
    }
  }
  render() {
    const { onClose, img, onSaveImagesAnotated } = this.props;
    const { image, images } = this.state;
    return (

      <Form
        headline={'Annotate Image'}
        onClose={() => { this.hideMarkers(); onClose() }}
        actions={(
          <>
            {this.state.loader ? <Loader center={true} /> : null}
            <div />
            <Button
              color="complete_purple"
              size="small"
              label="Done"
              onClick={() => { this.hideMarkers(); onSaveImagesAnotated(images) }}
              disabled={false}
            />
          </>
        )}
        component={(
          <Row mdCenter>
            <Col
              xs="12"
              md="6"
            >
              <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column'}}>

                <div style={{ marginTop: 40 }}>
                {/* <AspectRatio ratio="3/4" style={{ maxWidth: '400px'}}> */}
                  
                  <img id='imageToAnnotate' style={{width:'350px', height:'auto', margin:'0 auto !important',display:'block'}} 
                   src={image} onClick={() => this.showMarkerJs()} />
                {/* </AspectRatio> */}
                </div>
                <div style={{ paddingTop: 10 }}>
                  Note: Tap the image to annotate.
              </div>
                {
                  this.state.images.length > 1 ?
                    <div style={{ display: 'flex', paddingTop: 40 }}>
                      {this.state.images.map((data, index) =>
                        <div style={{ padding: 10, borderStyle: this.state.index === index ? 'dotted' : "none" }} onClick={() => { this.setState({ image: data, index: index });this.hideMarkers(false); }}>
                          <img src={data} height='50' width='50' />
                        </div>)
                      }
                    </div>
                    :
                    null
                }
              </div>
            </Col>
          </Row>
        )}
      />

    )
  }
}



export default Marker;

